import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem, darken } from 'polished';
import { TextP } from '../../Defaults/Text';
import { FlexCol, FlexBetween } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TableTd, TableRow, DefaultTableTd, CellText } from '../General/Table';
import {
  getInvoiceDetailInfo,
  getOrderRowInfo,
  getRequestRowInfo,
  getAccountRowInfo,
} from '../../../utilities/selectors';
import { SvgIcon, IconType } from '../General/SvgIcon';
import { getRequestIcon, getRequestColor } from '../../../utilities';

export interface Props {
  account: any;
  theme: any;
  onDelete: (id: number) => void;
}

function AccountRow({ account, theme, onDelete }: Props) {
  const { id, name, surname, email, orders, requests } = getAccountRowInfo(
    account,
  );

  return (
    <StyledTableRow>
      <StyledTableTd>
        <StyledCellText>{`${name} ${surname}`}</StyledCellText>
      </StyledTableTd>
      <StyledTableTd>
        <StyledCellText>{email}</StyledCellText>
      </StyledTableTd>
      <StyledTableTd>
        <Count>{orders}</Count>
      </StyledTableTd>
      <StyledTableTd>
        <Count>{requests}</Count>
      </StyledTableTd>
      <StyledTableTd />
      <StatusTd>
        <SvgIcon
          // tslint:disable-next-line:jsx-no-lambda
          onClick={() => onDelete(id)}
          width={16}
          height={16}
          icon={IconType.trash}
          viewBox="0 0 16 16"
          alt="Odstrániť účet"
          title="Odstrániť účet"
          fill={theme.colors.textPrimary}
          cursor={'pointer'}
        />
      </StatusTd>
    </StyledTableRow>
  );
}

const StyledTableTd = styled(TableTd)`
  padding: ${rem(16)} ${rem(24)};
  border-bottom: ${({ theme }) => theme.borders.primary};
`;

const StatusTd = styled(StyledTableTd)`
  display: flex;
  align-items: center;
  height: ${rem(57)};
`;

const StyledTableRow = styled(TableRow)`
  padding: ${rem(24)} 0;
  border-top: ${({ theme }) => theme.borders.primary};

  &:last-child {
    border-bottom: ${({ theme }) => theme.borders.primary};
  }
`;

const StyledCellText = styled(CellText)``;

const Count = styled(StyledCellText)`
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${rem(12)};
  font-family: ${({ theme }) => theme.font.tertiary};
  line-height: ${rem(20)};
  background: rgb(49, 39, 131, 0.08);
  text-align: center;
  border-radius: 50%;
  padding: ${rem(3)} ${rem(12)} ${rem(4)};
  height: ${rem(24)};
  width: fit-content;
  margin: 0 auto;
`;

const WithThemeRow: any = withTheme(AccountRow);
export { WithThemeRow as AccountRow };
